import { colors } from './colors'

export const STATUS = {
  0: colors.error,
  1: colors.success,
  2: colors.warning,
  loading: colors.primary
}
